import { ChevronRight } from "lucide-react";
import React from "react";
import Flex from "@/components/layout/Flex";
import Typography from "@/components/shared/Typography";
import Button from "@/components/ui/Button";
import Drawer from "@/components/ui/Drawer";
import { getServiceCategories } from "@/content/helpers";
import { URLS } from "@/lib/consts";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { ServicesSlideProps } from "../types";
import Slide from "./slide";

export const SERVICES_SLIDE_INDEX = 10;
const SERVICE_CATEGORIES = getServiceCategories();

function ServicesSlide({
  index = SERVICES_SLIDE_INDEX,
  goToSlide,
  className,
  ...props
}: ServicesSlideProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Slide index={index} className={cn(className, classes)} {...native}>
      <Flex.Row className="relative w-full" justify="between" items="center">
        <Button.Icon
          className="absolute left-0 border-foreground"
          icon="arrow-left"
          variant="outline"
          onClick={() => goToSlide(0)}
          aria-label="Go Back"
        />

        <Typography.H2 className="w-full flex flex-1 justify-center items-center">
          Services
        </Typography.H2>
      </Flex.Row>

      <Drawer.Close asChild>
        <Button.Link
          href={URLS.SERVICES.ROOT}
          variant="ghost"
          className="w-full flex flex-row justify-between items-center rounded-none border-foreground border-b-2"
          aria-label="Go to the Services Page"
        >
          <Typography.Small className="text-left text-sm leading-none font-medium w-full">
            Explore Our Services
          </Typography.Small>
          <ChevronRight />
        </Button.Link>
      </Drawer.Close>

      {SERVICE_CATEGORIES.map((item, index) => (
        <Button
          key={item.label}
          variant="ghost"
          className="w-full h-auto flex flex-row justify-between items-center rounded-none border-foreground border-b-2"
          onClick={() => goToSlide(SERVICES_SLIDE_INDEX + index + 1)}
          aria-label={`Go to the ${item.label} Page`}
        >
          <Flex.Column justify="start" items="start">
            <Typography.Small className="text-left text-sm leading-none font-medium w-full">
              {item.label}
            </Typography.Small>

            <Typography.Small className="text-left text-muted-foreground line-clamp-2 text-sm leading-snug w-full">
              {item.description}
            </Typography.Small>
          </Flex.Column>
          <ChevronRight />
        </Button>
      ))}
    </Slide>
  );
}

export default ServicesSlide;
